// extracted by mini-css-extract-plugin
module.exports = {"container":"NsTabs_container_14C4K","tabsBar":"NsTabs_tabsBar_3SzFm","sliderWrapper":"NsTabs_sliderWrapper_188gN","slider":"NsTabs_slider_24ax6"};